"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowSelectEditor_1 = require("../../../../shared/components/editors/CardRowSelectEditor");
var DlgSetPProgramPartnerOffer = /** @class */ (function (_super) {
    __extends(DlgSetPProgramPartnerOffer, _super);
    function DlgSetPProgramPartnerOffer(props) {
        var _this = _super.call(this, props) || this;
        _this.SID_PP = 0;
        _this.SID_PP_P = 0;
        _this.SID_PP_O = 0;
        return _this;
    }
    DlgSetPProgramPartnerOffer.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.dialogTitle,
                pprogram_id: 0,
                pprogram_title: "",
                pprograms_avail: [],
                offer_id: 0,
                offer_title: "",
                offers_avail: [],
                partner_id: 0,
                partner_login: "",
                partners_avail: []
            }, function () {
                if (_this.state.visible) {
                    _this.props.listAffilatesAvail.LoadData();
                }
            });
        });
        this.setState({
            visible: false,
            dialogTitle: "",
            pprogram_id: 0,
            pprogram_title: "",
            pprograms_avail: [],
            offer_id: 0,
            offer_title: "",
            offers_avail: [],
            partner_id: 0,
            partner_login: "",
            partners_avail: []
        });
        this.doReSetRules();
        this.SID_PP = this.props.listAffilatesAvail.Subscribe("*", function (id, data) {
            _this.setState({
                pprograms_avail: data.data,
                pprogram_id: 0,
                pprogram_title: "",
                offer_id: 0,
                offer_title: "",
                offers_avail: [],
                partner_id: 0,
                partner_login: "",
                partners_avail: []
            });
        });
        this.SID_PP_P = this.props.listAffilatesPartnersAvail.Subscribe("*", function (id, data) {
            _this.setState({
                offer_id: 0,
                offer_title: "",
                offers_avail: [],
                partner_id: 0,
                partner_login: "",
                partners_avail: data.data
            });
        });
        this.SID_PP_O = this.props.listAffilatesPartnersOffersAvail.Subscribe("*", function (id, data) {
            _this.setState({
                offer_id: 0,
                offer_title: "",
                offers_avail: data.data
            });
        });
    };
    DlgSetPProgramPartnerOffer.prototype.doReSetRules = function () {
        this.setState({
            pprogram_rules: { isError: false },
            offer_rules: { isError: false },
            partner_rules: { isError: false }
        });
    };
    DlgSetPProgramPartnerOffer.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
        this.props.listAffilatesAvail.UnSubscribe(this.SID_PP);
        this.props.listAffilatesPartnersAvail.UnSubscribe(this.SID_PP_P);
        this.props.listAffilatesPartnersOffersAvail.UnSubscribe(this.SID_PP_O);
    };
    DlgSetPProgramPartnerOffer.prototype.isDataValid = function () {
        this.doReSetRules();
        var is_data_valid = true;
        if (this.state.pprogram_id <= 0) {
            this.setState({
                pprogram_rules: {
                    isError: true,
                    errorMessage: "Поле [П.Программа] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        if (this.state.offer_id <= 0) {
            this.setState({
                offer_rules: {
                    isError: true,
                    errorMessage: "Поле [Оффер] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        if (this.state.partner_id <= 0) {
            this.setState({
                partner_rules: {
                    isError: true,
                    errorMessage: "Поле [Партнер] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        return is_data_valid;
    };
    DlgSetPProgramPartnerOffer.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.pprogram_id, this.state.partner_id, this.state.offer_id);
            }
        }
    };
    DlgSetPProgramPartnerOffer.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgSetPProgramPartnerOffer.prototype.render = function () {
        var _this = this;
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: true, maskClosable: false, okType: "primary", style: { minWidth: 600 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "П.Программа:", placeholder: "Выберите партнерскую программу" }, value: { key: this.state.pprogram_id, value: this.state.pprogram_title }, onValueChanged: function (newVal) {
                        _this.setState({
                            pprogram_id: newVal.key,
                            pprogram_title: newVal.value,
                            pprogram_rules: { isError: false }
                        }, function () {
                            _this.props.listAffilatesPartnersAvail.LoadData(_this.state.pprogram_id);
                            //this.props.controller.SetPProgramId(this.state.pprogram_id);
                            //this.props.controller.SetPProgramTitle(this.state.pprogram_title);
                        });
                    }, items: this.state.pprograms_avail, required: true, rules: this.state.pprogram_rules }),
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Партнер :", placeholder: "Выберите партнера" }, value: { key: this.state.partner_id, value: this.state.partner_login }, onValueChanged: function (newVal) {
                        _this.setState({
                            partner_id: newVal.key,
                            partner_login: newVal.value,
                            partner_rules: { isError: false }
                        }, function () {
                            _this.props.listAffilatesPartnersOffersAvail.LoadDataKeysAreUsrPartnerOfferId(_this.state.partner_id);
                        });
                    }, items: this.state.partners_avail, required: true, rules: this.state.partner_rules }),
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Оффер:", placeholder: "Выберите значение оффера" }, value: { key: this.state.offer_id, value: this.state.offer_title }, onValueChanged: function (newVal) {
                        _this.setState({
                            offer_id: newVal.key,
                            offer_title: newVal.value,
                            offer_rules: { isError: false }
                        }, function () {
                            //this.props.controller.SetDnmVal(this.state.dnm_val);
                        });
                    }, items: this.state.offers_avail, required: true, rules: this.state.offer_rules, floatKey: true })));
    };
    return DlgSetPProgramPartnerOffer;
}(React.Component));
exports.default = DlgSetPProgramPartnerOffer;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgSetPProgramPartnerOffer.tsx
// module id = 2496
// module chunks = 0